import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function FinalCtaSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-950 via-pink-950/30 to-[#0d0b14] relative overflow-hidden" data-id="element-22">
      {/* Decorative sparkles */}
      <div className="absolute top-10 left-10 text-pink-500/40 opacity-50 animate-pulse" data-id="element-23">
        <Sparkles className="w-12 h-12" data-id="element-24" />
      </div>
      <div className="absolute bottom-10 right-10 text-purple-500/40 opacity-50 animate-pulse delay-300" data-id="element-25">
        <Sparkles className="w-16 h-16" data-id="element-26" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-28">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6" data-id="element-29">
            El momento perfecto para empezar no existe.
          </h2>

          <p className="text-xl sm:text-2xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-30">
            Pero sí existe el momento en que decides tomar una nueva dirección.{' '}
            <br className="hidden sm:block" data-id="element-31" />
            <span className="font-semibold text-pink-400" data-id="element-32">
              Hoy puede ser ese momento.
            </span>
          </p>

          <motion.a href="https://pay.hotmart.com/R104785188L" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="px-8 py-4 bg-gradient-primary text-white rounded-full font-bold text-lg shadow-xl shadow-pink-500/40 hover:shadow-pink-500/60 transition-all inline-flex items-center justify-center gap-2 mx-auto" data-id="element-33">
            <span data-id="element-34">QUIERO VOLVER A BRILLAR</span>
            <Sparkles className="w-5 h-5" data-id="element-35" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}